import React from 'react';
import Styles from '../assets/css/productDetail.module.scss';
import Loader from '../utils/Loader';

const TransactionTable = ({
    isOutbound,
    productData,
    transactionId,
    loading,
    productsData,
    setProductId,
    productTransactionDataWithQuantity,
    skuQuantities
}) => {
    const getTransactionId = () => {
        if (isOutbound) {
            return productData?.product_transaction?.transaction_id || 'New';
        }
        return transactionId;
    };

    // Get display quantity from transaction data (TOTAL quantity)
    const getDisplayQuantity = (item) => {
        const transactionItem = productTransactionDataWithQuantity?.find(transItem =>
            String(transItem.id) === String(item.id)
        );
        return transactionItem ? transactionItem.quantity : (item.quantity || 0);
    };

    // Get SKU details for display
    const getSkuDetails = (item) => {
        if (item.lazada_product?.data?.skus?.length > 1) {
            // For multiple SKUs, show the main SKU number
            return item.sku_number || 'Multiple SKUs';
        }
        return item.sku_number || 'N/A';
    };

    // Get product name with SKU info for multiple SKU products
    const getProductDisplayName = (item) => {
        const baseName = item.product_name || 'N/A';

        if (item.lazada_product?.data?.skus?.length > 1) {
            const transactionItem = productTransactionDataWithQuantity?.find(transItem =>
                String(transItem.id) === String(item.id)
            );

            if (transactionItem?.skuQuantities) {
                const activeSkus = Object.entries(transactionItem.skuQuantities)
                    .filter(([_, quantity]) => quantity > 0)
                    .length;

                if (activeSkus > 0) {
                    return `${baseName} (${activeSkus} variant${activeSkus > 1 ? 's' : ''})`;
                }
            }

            return `${baseName} (Multiple variants)`;
        }

        return baseName;
    };

    return (
        <div className={`${Styles.transaction}`}>
            <div className={`${Styles.transaction_table}`}>
                <h1>Current Transaction #{getTransactionId()}</h1>

                {loading ? (
                    <div className={`${Styles.table_loading}`}>
                        <Loader size="large" color="black" />
                    </div>
                ) : (
                    <table>
                        <thead>
                            <tr>
                                <th className={`${Styles.first_row}`}>SKU #</th>
                                <th>Product name</th>
                                <th>Total Qty</th>
                            </tr>
                        </thead>
                        <tbody>
                            {productsData?.map((item) => (
                                <tr
                                    key={item.id}
                                    onClick={() => setProductId(item.id)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <td className={`${Styles.first_row}`}>
                                        {getSkuDetails(item)}
                                    </td>
                                    <td className={`${Styles.product_name}`}>
                                        {getProductDisplayName(item)}
                                    </td>
                                    <td><strong>{getDisplayQuantity(item)}</strong></td>
                                </tr>
                            ))}
                            {(!productsData || productsData.length === 0) && (
                                <tr>
                                    <td colSpan="3" style={{ textAlign: 'center' }}>
                                        No products in transaction
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

export default TransactionTable;